import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { StaffService } from 'src/app/services/Staff/staff.service';


@Component({
  selector: 'app-employee-category',
  templateUrl: './employee-category.component.html',
  styleUrls: ['./employee-category.component.css']
})
export class EmployeeCategoryComponent implements OnInit {


  Submitted: boolean = false;
  EmployeeCategoryList: any;

  constructor(private staffservice: StaffService, private globalHelper: GlobalHelper,private spinnerService: Ng4LoadingSpinnerService) { }

  EmpCategoryModel = {
    EmployeeCategoryID: 0,
    EmployeeCategory: '',
    EmployeeCategoryCode:'',
    IsActive: true
  };

  Clear() {
    this.EmpCategoryModel.EmployeeCategoryID = 0;
    this.EmpCategoryModel.EmployeeCategory = '';
    this.EmpCategoryModel.EmployeeCategoryCode = '';
    this.EmpCategoryModel.IsActive = true;
    this.Submitted = false;
  };

  GetAllEmployeeCategory() {
    this.spinnerService.show();
    this.staffservice.GetAllEmployeeCategory().subscribe((response: any) => {
      this.EmployeeCategoryList = response.EmployeeCategoryList;
      this.globalHelper.CheckActionStatus(response);
      this.spinnerService.hide();
    });
  };


  SaveEmployeeCategory(valid) {
    this.Submitted = true;
    if (valid) {
      this.spinnerService.show();
      this.staffservice.SaveEmployeeCategory(JSON.stringify(this.EmpCategoryModel)).subscribe((data: any) => {
        if (data.webResponse.Status) {        
          this.GetAllEmployeeCategory();
        }
        if (data.webResponse.Status && this.EmpCategoryModel.EmployeeCategoryID==0) {
          this.Clear();
          this.GetAllEmployeeCategory();
        }
        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }
  };

  EmployeeCategoryMarkActive(item) {
    this.EmpCategoryModel.EmployeeCategoryID = item.EmployeeCategoryID;
    this.EmpCategoryModel.IsActive = item.IsActive == true ? false : true;
    this.staffservice.EmployeeCategoryMarkActive(JSON.stringify(this.EmpCategoryModel)).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.Clear();
        this.GetAllEmployeeCategory();
      }
      this.globalHelper.CheckActionStatus(data);
    });

  };


  Edit(obj) {

    this.EmpCategoryModel.EmployeeCategoryID = obj.EmployeeCategoryID;
    this.EmpCategoryModel.EmployeeCategory = obj.EmployeeCategory;
    this.EmpCategoryModel.EmployeeCategoryCode = obj.EmployeeCategoryCode;
    this.EmpCategoryModel.IsActive = obj.IsActive;


  };


  // Init and Lookup

  ngOnInit() {
   
    this.GetAllEmployeeCategory();
  }

 
}

